import apiClient from 'helpers/api-client';
import { Steven } from 'helpers/steven';

import type { PaymentRequest, BasePaymentRequestInput } from '../types';

type UseCreatePaymentRequestArgs = {
  projectDatabaseId: number;
  eventSource: string;
  onSuccess?: (paymentRequest: PaymentRequest) => void;
  onError?: (errorMessage: string) => void;
};

export type PaymentRequestCreateInput = BasePaymentRequestInput;

const NOOP = () => {};

export const useCreatePaymentRequest = ({
  projectDatabaseId,
  eventSource,
  onSuccess = NOOP,
  onError = NOOP,
}: UseCreatePaymentRequestArgs) => {
  const createPaymentRequest = async ({
    title,
    amount,
    memo,
    status,
  }: PaymentRequestCreateInput) => {
    try {
      const res = await apiClient.post(
        `/locations/${projectDatabaseId}/payment_requests`,
        {
          payment_request: {
            title,
            amount,
            memo,
            status,
          },
        },
      );

      if (res.id) {
        Steven.entityCrud({
          entity_id: `${res.id}`,
          entity_type: 'payment_request',
          action: 'created',
          source: eventSource,
        });
      }

      onSuccess(res);
    } catch (error) {
      onError(error.message);
    }
  };

  return { createPaymentRequest };
};
